import React, { Component } from "react";
import "../Menu.css";
import Back from "../assets/back_white.svg";
// import { OverlayTrigger, Tooltip } from "react-bootstrap";
import CustomButton from "../components/CustomButton";
import Category from "../components/Category";
import Group from "../components/Group";
import Tick from "../images/tick.svg";
import Cancel from "../images/cancel.svg";
import Logout from "../images/logout.svg";
import Profilee from "../images/profile.svg";
import plus from "../images/plus.svg";
import addimage from "../images/addimage.svg";
import noimage from "../images/noimage.png";
import { Form } from "react-bootstrap";
import Phone from "../images/phonebrown.svg";
import Address from "../images/addressbrown.svg";
import Email from "../images/email.png";
import logo from "../images/sepandlogo.png";
// import ScrollContainer from 'react-indiana-drag-scroll'
import Loading from "../components/Loading";
import SelectLangItem from "../components/SelectLangItem";
import axios from "axios";
import { toast } from "react-toastify";
import { ClapSpinner } from "react-spinners-kit";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { Modal } from "react-bootstrap";
import Profile from "./Profile";
import { word } from "../words.js";
import Tooltip from "@mui/material/Tooltip";
import Dropzone from "react-dropzone";
import ListViewer from "../components/ListViewer";
import {
  BaseUrl,
  Authorization,
  BaseUrlAssets,
  BaseUrlPublic,
  isUser,
  LogoutFunction,
} from "../static.js";

export default class Menu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      resNameErrorText: "",
      descriptionErrorText: "",
      resNameValue: "",
      descriptionValue: "",
      buttonDisabled: false,
      actionError: "",
      Menu: [],
      MenuCat: [],
      activeIndex: 0,
      loading: true,
      resID: null,
      logoUrl: null,
      headerUrl: null,
      logoFileName: "",
      headerFileName: "",
      uploadButtonDisable: false,
      uploadButtonDisableHeader: false,
      newCat: false,
      categoryValue: "",
      catButtonDisabled: false,
      resetCategoryEditMode: false,
      resTypeValue: "",
      emailValue: "",
      phoneNumValue: "",
      addressValue: "",
      priceUnitValue: "",
      businessTypeValue: "",
      currenCategoryEditMode: null,
      ModalShow: false,
      userLangList: [],
      rtlClass: " rtlStyle",
      langMenuTop: 0,
      langMenuLeft: 0,
      showLangMenu: false,
      widthh: 0,
      selectedLangId: -1,
      currentLangTitle: "",
      businessInfo: [],
      selectedLangIndex: 0,
      subTitlee: "",
      currentLang: "",
      defaultLangId: "",
      groupEditId: "",
      orderProcess: [],
      selectedOrderProcess: [],
      currentFoodId: null,
      ModalShowOrderProcess: false,
      addProcessToItemLoading: false,
    };
    this.textHandleChange = this.textHandleChange.bind(this);
    this.getMenu = this.getMenu.bind(this);

    this.inputFile = React.createRef();
    this.NameInput = React.createRef();
    this.inputFileHeader = React.createRef();
    this.onUploadLogoClick = this.onUploadLogoClick.bind(this);
    this.onUploadHeaderClick = this.onUploadHeaderClick.bind(this);
    this.uploadImage = this.uploadImage.bind(this);
    this.resetCatPriority = this.resetCatPriority.bind(this);
    this.doneCatClick = this.doneCatClick.bind(this);
    this.getUserLanguageList = this.getUserLanguageList.bind(this);
    this.setLangMenuPosition = this.setLangMenuPosition.bind(this);

    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.createOrUpdateProduct = this.createOrUpdateProduct.bind(this);

    this.languageButton = React.createRef();
    this.languageMenu = React.createRef();
  }

  componentDidMount() {
    // console.log("cookie: ",document.cookie);
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);

    window.addEventListener("scroll", this.handleScroll);

    document.addEventListener("mousedown", this.handleClickOutside);

    let data = {
      // languageId: 1,
      businessCode: this.props.match.params.id,
    };
    if (isUser) data = Object.assign(data, Authorization());
    fetch((isUser ? BaseUrl : BaseUrlPublic) + "findBusinessWithCode", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        // console.log(result);
        if (result.status === 200) {
          console.log("findBusinessWithCode", result);
          // this.setState({resNameValue:result.result[0].name,descriptionValue:result.result[0].descr,resID:result.result[0].id});
          // this.setState({businessInfo:result,resID:result.result[0].id,priceUnitValue:result.result[0].priceUnit,businessTypeValue:result.result[0].businessType,resNameValue:result.result[0].name,subTitle:result.result[0].descr,emailValue:result.result[0].email,phoneNumValue:result.result[0].phoneNumber,addressValue:result.result[0].address,descriptionValue:result.result[0].descr})
          this.setState({
            businessInfo: result,
            resID: result.result[0].id,
            businessTypeValue: result.result[0].businessType,
            emailValue: result.result[0].email,
            phoneNumValue: result.result[0].phoneNumber,
          });
          if (result.result[0].headerPic !== "") {
            this.setState({
              headerUrl: BaseUrlAssets + result.result[0].headerPic,
              headerFileName: result.result[0].headerPic,
            });
          }

          if (result.result[0].logo !== "") {
            this.setState({
              logoUrl: BaseUrlAssets + result.result[0].logo,
              logoFileName: result.result[0].logo,
            });
          }

          // this.getMenu()
          this.getUserLanguageList(result.result[0].id);
        } else {
          this.props.goToBusinessList();
        }
        // console.log("findBusinessWithCode:",result);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
    window.removeEventListener("resize", this.updateWindowDimensions);
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  handleScroll() {
    this.setLangMenuPosition();
  }

  handleClickOutside(event) {
    try {
      if (
        this.languageMenu.current &&
        !this.languageMenu.current.contains(event.target) &&
        this.languageButton.current &&
        !this.languageButton.current.contains(event.target)
      ) {
        this.setState({ showLangMenu: false });
      }
    } catch (error) {}
  }

  setLangMenuPosition() {
    try {
      if (this.state.showLangMenu) {
        let top = 0;
        if (window.innerWidth < 768)
          top =
            this.languageButton.current.getBoundingClientRect().top +
            this.languageButton.current.getBoundingClientRect().height +
            3;
        else
          top =
            this.languageButton.current.getBoundingClientRect().top -
            this.languageMenu.current.getBoundingClientRect().height -
            3;
        this.setState({
          langMenuTop: top,
          langMenuLeft:
            this.languageButton.current.getBoundingClientRect().left +
            this.languageButton.current.getBoundingClientRect().width / 2 -
            this.languageMenu.current.getBoundingClientRect().width / 2,
        });
      }

      this.setState({ widthh: window.innerWidth });
    } catch (error) {}
  }

  getUserLanguageList(id) {
    let data = {
      businessId: id,
      businessCode: this.props.match.params.id,
    };

    data = Object.assign(data, Authorization());

    fetch(BaseUrl + "getBusinessLanguages", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.status === 200) {
          // console.log('getBusinessLanguages',result.result);
          let defaultId = 0;
          let title = 0;
          let tag = "";
          let index = 0;
          let i = 0;
          // console.log('result.result',result.result);
          result.result.forEach((element) => {
            if (element.defaultLanguage) {
              title = element.title;
              defaultId = element.languageId;
              tag = element.tag;
              index = i;
            }
            i++;
          });

          let aa = result.result;

          let defaultName = "";
          // console.log('this.state.businessInfo.info',this.state.businessInfo.info);
          this.state.businessInfo.info.forEach((element) => {
            // if (element.languageId===defaultId){
            //     this.setState({resNameValue:element.name,subTitle:element.descr,addressValue:element.address,descriptionValue:element.descr})
            // }

            aa.forEach((element1) => {
              if (element.languageId === element1.languageId) {
                if (element.languageId === defaultId)
                  defaultName = element.name;
                element1.name = element.name;
                element1.address = element.address;
                element1.descr = element.descr;
              }
            });
          });

          // this.state.userLangList[index].direction

          this.setState(
            {
              userLangList: aa,
              priceUnitValue:
                aa[index].direction === "rtl"
                  ? this.state.businessInfo.result[0].rtlPriceTitle
                  : this.state.businessInfo.result[0].ltrPriceTitle,
              selectedLangId: defaultId,
              defaultLangId: defaultId,
              currentLangTitle: title,
              currentLang: tag,
              selectedLangIndex: index,
              subTitlee: defaultName,
            },
            () => {
              if (this.state.userLangList.length > 0) {
                if (
                  this.state.userLangList[index].direction.toLowerCase() ===
                  "rtl"
                ) {
                  this.setState({ rtlClass: " rtlStyle" });
                } else {
                  this.setState({ rtlClass: " ltrStyle" });
                }
              }

              this.getMenu(defaultId);
            }
          );
        } else if (result.status === 401) {
          LogoutFunction();
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  getMenu(id) {
    let data = {
      languageId: id,
      type: "getMenuWithBusinessCode",
      businessCode: this.props.match.params.id,
    };
    data = Object.assign(data, Authorization());

    // console.log(data);

    fetch(BaseUrl + "getMenu", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        console.log("getMenuuuuuu:", result);

        let menucat = [];
        for (let i = result.result.length - 1; i > 0; i--) {
          menucat.push(result.result[i]);
        }

        this.setState(
          {
            Menu: result.result,
            MenuCat: menucat,
          },
          () => {
            this.readOrderProcess();
          }
        );
      })
      .catch((err) => {
        console.log(err);
      });
  }

  readOrderProcess() {
    let data = {
      businessCode: this.props.match.params.id,
    };
    data = Object.assign(data, Authorization());

    fetch(BaseUrl + "readOrderProcess", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        console.log("readOrderProcess:", result);
        if (result.status === 200) {
          this.setState({
            loading: false,
            orderProcess: result.result,
          });
        } else if (result.status === 403) {
          this.setState({
            loading: false,
            orderProcess: [],
          });
        } else {
          toast.error(result.message, {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 6000,
            toastClassName: "toast",
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  onUploadLogoClick(event) {
    if (
      event.target.files[0] !== undefined &&
      (event.target.files[0].type === "image/jpg" ||
        event.target.files[0].type === "image/png" ||
        event.target.files[0].type === "image/jpeg")
    ) {
      this.uploadImage(event.target.files[0], "logo");
    }
  }

  onUploadHeaderClick(event) {
    if (
      event.target.files[0] !== undefined &&
      (event.target.files[0].type === "image/jpg" ||
        event.target.files[0].type === "image/png" ||
        event.target.files[0].type === "image/jpeg")
    ) {
      this.uploadImage(event.target.files[0], "banner");
    }
  }

  uploadImage(file, type) {
    const data = new FormData();
    data.append("file", file);
    data.append("type", type);
    if (type === "banner") {
      this.setState({ uploadButtonDisableHeader: true });
    } else {
      this.setState({ uploadButtonDisable: true });
    }

    axios
      .post(BaseUrl + "uploadfile", data)
      .then((res) => {
        console.log(res);
        if (res.data.status === 200) {
          let text = "";
          if (type === "banner") {
            text = "بارگذاری بنر با موفقیت انجام شد";
            this.setState(
              {
                headerUrl: BaseUrlAssets + res.data.data.fileName,
                headerFileName: res.data.data.fileName,
              },
              () => {
                this.editBusiness("header");
              }
            );
          } else {
            text = "بارگذاری لوگو با موفقیت انجام شد";
            this.setState(
              {
                logoUrl: BaseUrlAssets + res.data.data.fileName,
                logoFileName: res.data.data.fileName,
              },
              () => {
                this.editBusiness("logo");
              }
            );
          }

          toast.success(text, {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 6000,
            toastClassName: "toast",
          });
        } else {
          toast.error(res.data.message, {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 6000,
            toastClassName: "toast",
          });
        }

        if (type === "banner") {
          this.setState({ uploadButtonDisableHeader: false });
        } else {
          this.setState({ uploadButtonDisable: false });
        }
      })
      .catch((err) => {
        if (type === "banner") {
          this.setState({ uploadButtonDisableHeader: false });
        } else {
          this.setState({ uploadButtonDisable: false });
        }
        toast.error(err.message, {
          position: toast.POSITION.BOTTOM_RIGHT,
          hideProgressBar: true,
          autoClose: 6000,
          toastClassName: "toast",
        });
        console.log(err);
      });
  }

  editBusiness(type) {
    if (isUser) {
      toast.error("شما مجوز دسترسی مربوطه را ندارید.", {
        position: toast.POSITION.BOTTOM_RIGHT,
        hideProgressBar: true,
        autoClose: 6000,
        toastClassName: "toast",
      });
      return;
    }
    let userlangs = JSON.parse(JSON.stringify(this.state.userLangList));

    userlangs.forEach((element) => {
      if (element.name === undefined) element.name = "";
      if (element.address === undefined) element.address = "";
      if (element.descr === undefined) element.descr = "";
      delete element.direction;
      delete element.tag;
      delete element.flag;
      delete element.id;
      delete element.title;
      delete element.selected;
      delete element.default;
      delete element.defaultLanguage;
      delete element.businessId;
    });

    let data = {
      businessType: Number(this.state.businessTypeValue),
      priceUnit: this.state.businessInfo.result[0].priceUnit,
      info: userlangs,
      email: this.state.emailValue,
      phoneNumber: this.state.phoneNumValue,
      logo: this.state.logoFileName,
      headerPic: this.state.headerFileName,
      id: this.state.resID,
    };
    data = Object.assign(data, Authorization());
    console.log(data);
    fetch(BaseUrl + "editBusiness", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        console.log(result);
        if (result.status === 200) {
          if (type === "logo") {
            this.setState({ uploadButtonDisable: false });
          } else if (type === "header") {
            this.setState({ uploadButtonDisableHeader: false });
          } else {
            this.props.history.push(
              "/Restaurants/" + this.props.match.params.id
            );
          }
        } else if (result.status === 401) {
          LogoutFunction();
        }
      })
      .catch((err) => {
        if (type === "logo") {
          this.setState({ uploadButtonDisable: false });
        } else if (type === "header") {
          this.setState({ uploadButtonDisableHeader: false });
        } else {
          this.props.history.push("/Restaurants/" + this.props.match.params.id);
        }
        console.log(err);
      });
  }

  onBack() {
    // this.props.history.goBack()
    // this.props.history.push("/Restaurants/"+this.props.match.params.id)
  }

  cancelPageClick() {
    // this.props.history.goBack()
    this.props.history.push("/Restaurants/" + this.props.match.params.id);
  }

  donePageClick() {
    this.editBusiness("text");
  }

  textHandleChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  uploadHeaderClick() {
    this.inputFileHeader.current.click();
  }

  uploadLogoClick() {
    this.inputFile.current.click();
  }

  newCatClick() {
    this.setState(
      { newCat: true, categoryValue: "", resetCategoryEditMode: true },
      () => {
        this.NameInput.current.focus();
        this.setState({ resetCategoryEditMode: false });
      }
    );
  }

  doneCatClick() {
    let data = {
      languageId: this.state.selectedLangId,
      name: this.state.categoryValue,
      businessId: this.state.resID,
      businessCode: this.props.match.params.id,
      startTime: null,
      endTime: null,
      isEnable: 1,
      priority: this.state.Menu.length,
    };
    data = Object.assign(data, Authorization());

    console.log(data);

    this.setState({ catButtonDisabled: true });

    fetch(BaseUrl + "createCategory", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.status === 200) {
          let menucat = [];
          for (let i = result.result.length - 1; i > 0; i--) {
            menucat.push(result.result[i]);
          }
          this.setState({
            catButtonDisabled: false,
            newCat: false,
            Menu: result.result,
            MenuCat: menucat,
          });
        } else if (result.status === 401) {
          LogoutFunction();
        } else {
          toast.error(result.message, {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 6000,
            toastClassName: "toast",
          });
          this.setState({ catButtonDisabled: false });
          this.NameInput.current.focus();
        }
      })
      .catch((err) => {
        console.log(err);
        this.setState({ newCat: false });
      });
  }

  cancelCatClick() {
    this.setState({ newCat: false });
  }

  onDragEnd(result) {
    var menu = JSON.parse(JSON.stringify(this.state.Menu));
    var tmenu = JSON.parse(JSON.stringify(this.state.Menu));
    var newResult = JSON.parse(JSON.stringify(result));

    if (
      newResult.destination !== null &&
      newResult.destination.index !== newResult.source.index
    ) {
      newResult.destination.index = Math.abs(
        newResult.destination.index - (menu.length - 1)
      );
      newResult.source.index = Math.abs(
        newResult.source.index - (menu.length - 1)
      );

      menu.splice(
        newResult.destination.index,
        0,
        menu.splice(newResult.source.index, 1)[0]
      );
      let i = 0;
      menu.forEach((element) => {
        element.priority = i;
        i++;
      });

      let menucat = [];
      for (let i = menu.length - 1; i > 0; i--) {
        menucat.push(menu[i]);
      }

      this.setState({ Menu: menu, MenuCat: menucat });

      var tempMenu = JSON.parse(JSON.stringify(menu));

      tempMenu.forEach((element) => {
        delete element.businessId;
        delete element.endTime;
        delete element.isEnable;
        delete element.items;
        delete element.name;
        delete element.startTime;
        delete element.nameObj;
        delete element.descrObj;
        delete element.onTax;
        delete element.packingPrice;
      });

      let data = {
        languageId: this.state.selectedLangId,
        businessId: this.state.resID,
        businessCode: this.props.match.params.id,
        categoryList: tempMenu,
      };
      data = Object.assign(data, Authorization());

      // console.log("data", data);

      fetch(BaseUrl + "changeCategoryPriority", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      })
        .then((res) => res.json())
        .then((resultt) => {
          // console.log(resultt);
          if (resultt.status !== 200) {
            this.setState({ Menu: tmenu });

            if (resultt.status === 401) {
              LogoutFunction();
            } else {
              toast.error(resultt.message, {
                position: toast.POSITION.BOTTOM_RIGHT,
                hideProgressBar: true,
                autoClose: 6000,
                toastClassName: "toast",
              });
            }
          } else {
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }

  onSubmit(api, data) {
    this.createOrUpdateProduct(api, data);
  }

  createOrUpdateProduct(api, data) {
    data = Object.assign(data, Authorization());
    data = Object.assign(data, { businessCode: this.props.match.params.id });
    fetch(BaseUrl + "" + api, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        console.log(result);
        if (result.status === 200) {
          let menucat = [];
          for (let i = result.result.length - 1; i > 0; i--) {
            menucat.push(result.result[i]);
          }
          this.setState({ Menu: result.result, MenuCat: menucat }, () => {
            if (api === "createProduct") {
              this.setState({
                currentFoodId: result.newItemId,
                selectedOrderProcess: [],
                ModalShowOrderProcess: true,
              });
            }
          });
        } else if (result.status === 401) {
          LogoutFunction();
        } else {
          toast.error(result.message, {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 6000,
            toastClassName: "toast",
          });
        }
      })
      .catch((err) => {
        console.log(err);
        this.setState({ newCat: false });
      });
  }

  onFoodsChangePriority(catId, oldIndex, newIndex) {
    if (oldIndex !== newIndex) {
      var oldMenu = JSON.parse(JSON.stringify(this.state.Menu));
      var menu = JSON.parse(JSON.stringify(this.state.Menu));
      var tempMenu = null;
      menu.forEach((element) => {
        if (catId === element.id) {
          element.items.splice(
            newIndex,
            0,
            element.items.splice(oldIndex, 1)[0]
          );
          let i = 0;
          element.items.forEach((element1) => {
            element1.priority = i;
            i++;
          });
          tempMenu = JSON.parse(JSON.stringify(element.items));
        }
      });

      let menucat = [];
      for (let i = menu.length - 1; i > 0; i--) {
        menucat.push(menu[i]);
      }

      this.setState({ Menu: menu, MenuCat: menucat });

      // console.log("last: ", tempMenu);

      tempMenu.forEach((element) => {
        delete element.businessId;
        delete element.endTime;
        delete element.isEnable;
        delete element.items;
        delete element.name;
        delete element.startTime;
        delete element.categoryId;
        delete element.descr;
        delete element.foodPicS1;
        delete element.foodPicS2;
        delete element.foodPicS3;
        delete element.price;
        delete element.descrObj;
        delete element.nameObj;
        delete element.onTax;
        delete element.taxPercent;
        delete element.packingPrice;
        delete element.OPWarning;
      });

      let data = {
        languageId: this.state.selectedLangId,
        businessId: Number(this.state.resID),
        businessCode: this.props.match.params.id,
        foodList: tempMenu,
      };
      data = Object.assign(data, Authorization());

      console.log("data", data);
      // return
      fetch(BaseUrl + "changeFoodPriority", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      })
        .then((res) => res.json())
        .then((result) => {
          console.log(result);
          if (result.status !== 200) {
            this.setState({ Menu: oldMenu });
            if (result.status === 401) {
              LogoutFunction();
            } else {
              toast.error(result.message, {
                position: toast.POSITION.BOTTOM_RIGHT,
                hideProgressBar: true,
                autoClose: 6000,
                toastClassName: "toast",
              });
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }

  onDeleteCategory(menu) {
    let menucat = [];
    for (let i = menu.length - 1; i > 0; i--) {
      menucat.push(menu[i]);
    }

    this.setState({ Menu: menu, MenuCat: menucat });
    // this.resetCatPriority(menu);
  }

  resetCatPriority(deleteResult) {
    var menu = JSON.parse(JSON.stringify(deleteResult));
    let i = 0;
    menu.forEach((element) => {
      element.priority = i;
      i++;
    });
    menu.forEach((element) => {
      delete element.businessId;
      delete element.endTime;
      delete element.isEnable;
      delete element.items;
      delete element.name;
      delete element.startTime;
    });

    let data = {
      languageId: this.state.selectedLangId,
      businessId: this.state.resID,
      businessCode: this.props.match.params.id,
      categoryList: menu,
    };
    data = Object.assign(data, Authorization());

    fetch(BaseUrl + "changeCategoryPriority", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        console.log(result);
        if (result.status !== 200) {
          if (result.status === 401) {
            LogoutFunction();
          } else {
            toast.error(result.message, {
              position: toast.POSITION.BOTTOM_RIGHT,
              hideProgressBar: true,
              autoClose: 6000,
              toastClassName: "toast",
            });
          }
        } else {
          let menucat = [];
          for (let i = result.result.length - 1; i > 0; i--) {
            menucat.push(result.result[i]);
          }

          this.setState({ Menu: result.result, MenuCat: menucat });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  onDuplicateCategory(menu) {
    let menucat = [];
    for (let i = menu.length - 1; i > 0; i--) {
      menucat.push(menu[i]);
    }
    this.setState({ Menu: menu, MenuCat: menucat });
  }

  updateCategory(id, name, isEnable, priority) {
    let data = {
      languageId: this.state.selectedLangId,
      name: name,
      id: id,
      businessId: this.state.resID,
      businessCode: this.props.match.params.id,
      startTime: null,
      endTime: null,
      isEnable: isEnable,
      priority: priority,
    };
    data = Object.assign(data, Authorization());

    console.log(data);

    fetch(BaseUrl + "updateCategory", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        console.log(result);
        if (result.status === 200) {
          let menucat = [];
          for (let i = result.result.length - 1; i > 0; i--) {
            menucat.push(result.result[i]);
          }
          this.setState({ Menu: result.result, MenuCat: menucat });
        } else if (result.status === 401) {
          LogoutFunction();
        } else {
          toast.error(result.message, {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 6000,
            toastClassName: "toast",
          });
        }
      })
      .catch((err) => {
        console.log(err);
        this.setState({ newCat: false });
      });
  }

  handleKeyPress(target) {
    if (target.charCode === 13) {
      this.doneCatClick();
    }
  }

  hideModal() {
    this.setState({ ModalShow: false });
  }

  onLogout() {
    LogoutFunction();
  }

  onProfile() {
    this.setState({ ModalShow: true });
  }

  onLanguageClick() {
    this.setState({ showLangMenu: !this.state.showLangMenu }, () => {
      this.setLangMenuPosition();
    });
  }

  updateWindowDimensions() {
    this.setLangMenuPosition();
  }

  onSelectLang(id, title, index, tag, direction) {
    this.setState(
      {
        selectedLangId: id,
        currentLangTitle: title,
        selectedLangIndex: index,
        currentLang: tag,
        priceUnitValue:
          this.state.userLangList[index].direction === "rtl"
            ? this.state.businessInfo.result[0].rtlPriceTitle
            : this.state.businessInfo.result[0].ltrPriceTitle,
      },
      () => {
        this.state.businessInfo.info.forEach((element) => {
          if (element.languageId === id) {
            this.setState({
              resNameValue: element.name,
              subTitle: element.descr,
              addressValue: element.address,
              descriptionValue: element.descr,
            });
          }
        });

        if (direction.toLowerCase() === "rtl") {
          this.setState({ rtlClass: " rtlStyle" });
        } else {
          this.setState({ rtlClass: " ltrStyle" });
        }

        this.setState({ showLangMenu: false });

        // this.getMenu(id);
      }
    );
  }

  onGroupEditMode(id) {
    this.setState({ groupEditId: id });
  }

  headerAcceptedFile(files) {
    console.log(files);

    this.uploadImage(files[0], "banner");
  }

  headerRejectedFiles(files) {
    switch (files[0].errors[0].code) {
      case "file-invalid-type": {
        toast.error("نوع فایل باید عکس باشد", {
          position: toast.POSITION.BOTTOM_RIGHT,
          hideProgressBar: true,
          autoClose: 6000,
          toastClassName: "toast",
        });
        break;
      }
      case "too-many-files": {
        toast.error("فقط یک عکس برای محصول انتخاب کنید", {
          position: toast.POSITION.BOTTOM_RIGHT,
          hideProgressBar: true,
          autoClose: 6000,
          toastClassName: "toast",
        });
        break;
      }
      default: {
        toast.error("مشکل در بارگذاری فایل", {
          position: toast.POSITION.BOTTOM_RIGHT,
          hideProgressBar: true,
          autoClose: 6000,
          toastClassName: "toast",
        });
        break;
      }
    }
    console.log(files);
  }

  logoAcceptedFile(files) {
    console.log(files);

    this.uploadImage(files[0], "logo");
  }

  logoRejectedFiles(files) {
    switch (files[0].errors[0].code) {
      case "file-invalid-type": {
        toast.error("نوع فایل باید عکس باشد", {
          position: toast.POSITION.BOTTOM_RIGHT,
          hideProgressBar: true,
          autoClose: 6000,
          toastClassName: "toast",
        });
        break;
      }
      case "too-many-files": {
        toast.error("فقط یک عکس برای محصول انتخاب کنید", {
          position: toast.POSITION.BOTTOM_RIGHT,
          hideProgressBar: true,
          autoClose: 6000,
          toastClassName: "toast",
        });
        break;
      }
      default: {
        toast.error("مشکل در بارگذاری فایل", {
          position: toast.POSITION.BOTTOM_RIGHT,
          hideProgressBar: true,
          autoClose: 6000,
          toastClassName: "toast",
        });
        break;
      }
    }
    console.log(files);
  }

  onConfirmOrderProcess(list) {
    let data = {
      businessId: this.state.resID,
      businessCode: this.props.match.params.id,
      itemId: this.state.currentFoodId,
      itemType: "food",
      orderProcessList: list,
    };
    data = Object.assign(data, Authorization());

    console.log(data);
    this.setState({ addProcessToItemLoading: true });
    fetch(BaseUrl + "addNewItemToOP", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        console.log(result);
        if (result.status === 200) {
          var menu = JSON.parse(JSON.stringify(this.state.Menu));
          menu.forEach((element) => {
            element.items.forEach((element1) => {
              if (element1.id === this.state.currentFoodId) {
                element1.OPWarning = false;
              }
            });
          });

          this.setState({
            Menu: menu,
            selectedOrderProcess: [],
            ModalShowOrderProcess: false,
            addProcessToItemLoading: false,
          });
        } else if (result.status === 401) {
          LogoutFunction();
        } else {
          toast.error("عملیات با مشکل مواجه شد", {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 6000,
            toastClassName: "toast",
          });
        }
      })
      .catch((err) => {
        console.log(err);
        this.setState({ addProcessToItemLoading: false });
      });
  }

  render() {
    if (!this.state.loading) {
      return (
        <div className="Login">
          <div className="header" style={{ height: "5vh" }}>
            <div />
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                height: "fit-content",
                alignItems: "center",
              }}
            >
              <Tooltip title="اطلاعات کاربری">
                <div
                  onClick={this.onProfile.bind(this)}
                  className="linkStyle backButton"
                  // data-tip="اطلاعات کاربری"
                  // data-place="right"
                >
                  <img src={Profilee} alt="" className="backButtonIcon" />
                </div>
              </Tooltip>
              <div
                style={{
                  height: "20px",
                  minWidth: "1px",
                  backgroundColor: "var(--brown1)",
                  margin: "0px 5px",
                }}
              />
              <Tooltip title="خروج">
                <div
                  onClick={this.onLogout.bind(this)}
                  className="linkStyle backButton"
                  // data-tip="خروج"
                  // data-place="bottom"
                >
                  <img src={Logout} alt="" className="backButtonIcon" />
                </div>
              </Tooltip>
            </div>
          </div>
          <div className="LoginContent">
            <div className="RestaurantsListTitle">منو</div>
            <div className="RestaurantsListSubTitle">
              {this.state.subTitlee}
            </div>
          </div>

          <div className="menuAlPageActionsContainer">
            <div style={{ width: "49%" }}>
              <CustomButton
                title="بازگشت"
                img={Back}
                backColor="var(--black1)"
                onClick={this.cancelPageClick.bind(this)}
                flexDirection="row-reverse"
                imgRotate="180"
              />
            </div>
            <Tooltip
              sx={{ textAlign: "right" }}
              title="فقط برای ذخیره اطلاعات متنی رستوران (نام رستوران و توضیحات و...) نیاز به فشردن این دکمه می‌باشد"
            >
              <div style={{ width: "49%" }}>
                <CustomButton
                  title="ذخیره"
                  img={Tick}
                  onClick={this.donePageClick.bind(this)}
                />
              </div>
            </Tooltip>
          </div>

          <div className="menuHeaderContainer">
            <img className="menuHeader" src={this.state.headerUrl} alt="" />
            {!this.state.uploadButtonDisableHeader && (
              <div className="changeHeaderButtonContainer">
                <CustomButton
                  title="بارگذاری بنر"
                  fontFamily="SFUIDisplay"
                  imgWidth={30}
                  imgHeight={30}
                  imgMarginLeft={5}
                  flexDirection="row-reverse"
                  img={addimage}
                  onClick={this.uploadHeaderClick.bind(this)}
                />
              </div>
            )}

            <div
              style={{
                position: "absolute",
                height: "100%",
                width: "100%",
                top: "0",
                left: "0",
              }}
            >
              <Dropzone
                accept="image/*"
                multiple={false}
                onDropAccepted={this.headerAcceptedFile.bind(this)}
                onDropRejected={this.headerRejectedFiles.bind(this)}
              >
                {({ getRootProps, getInputProps, isDragActive }) => (
                  <div {...getRootProps({ className: "dropzoneee" })}>
                    <input {...getInputProps()} />
                    {isDragActive ? (
                      <div
                        className="dropZoneContainer"
                        style={{ borderRadius: "0px" }}
                      >
                        <img
                          src={addimage}
                          alt=""
                          style={{
                            width: "40px",
                            height: "40px",
                            objectFit: "contain",
                            marginBottom: "5px",
                          }}
                        />
                        عکس را اینجا رها کنید
                      </div>
                    ) : null}
                  </div>
                )}
              </Dropzone>
            </div>

            {this.state.uploadButtonDisableHeader && (
              <div className="changeHeaderButtonContainer">
                <ClapSpinner
                  frontColor="var(--brown1)"
                  backColor="var(--brown1)"
                />
              </div>
            )}

            <img src={logo} alt="logo" className="gomenuLogo" />

            {this.state.widthh < 768 && (
              <div className="selectLangContainer1">
                <div ref={this.languageButton}>
                  <CustomButton
                    fontSize="12px"
                    minWidth="120px"
                    title={"زبان: " + this.state.currentLangTitle}
                    fontFamily="SFUIDisplay"
                    onClick={this.onLanguageClick.bind(this)}
                  />
                </div>
                {this.state.showLangMenu && (
                  <div
                    className="selectLangListContainer"
                    ref={this.languageMenu}
                    style={{
                      top: this.state.langMenuTop,
                      left: this.state.langMenuLeft,
                    }}
                  >
                    {this.state.userLangList.map((item, i) => (
                      <SelectLangItem
                        key={i}
                        direction={item.direction}
                        tag={item.tag}
                        index={i}
                        id={item.languageId}
                        totalCount={this.state.userLangList.length}
                        title={item.title}
                        selected={this.state.selectedLangId === item.id}
                        onSelectLang={this.onSelectLang.bind(this)}
                      />
                    ))}
                  </div>
                )}
              </div>
            )}
          </div>

          <input
            type="file"
            ref={this.inputFile}
            onChange={this.onUploadLogoClick}
            accept="image/png,.jpg"
            style={{ display: "none" }}
            disabled={this.state.uploadButtonDisable}
          />

          <input
            type="file"
            ref={this.inputFileHeader}
            onChange={this.onUploadHeaderClick}
            accept="image/png,.jpg"
            style={{ display: "none" }}
            disabled={this.state.uploadButtonDisableHeader}
          />

          <div id="allContainer" className="container Restinfo">
            <div className="row">
              <div className="col-md-2 col-2">
                <div className="logoRest">
                  <img
                    src={
                      this.state.logoUrl !== null ? this.state.logoUrl : noimage
                    }
                    alt=""
                    style={{
                      objectFit: "contain",
                      width: this.state.logoUrl !== null ? "100%" : "65%",
                      height: this.state.logoUrl !== null ? "100%" : "65%",
                    }}
                  />

                  <div
                    style={{
                      position: "absolute",
                      height: "100%",
                      width: "100%",
                      top: "0",
                      left: "0",
                    }}
                  >
                    <Dropzone
                      accept="image/*"
                      multiple={false}
                      onDropAccepted={this.logoAcceptedFile.bind(this)}
                      onDropRejected={this.logoRejectedFiles.bind(this)}
                    >
                      {({ getRootProps, getInputProps, isDragActive }) => (
                        <div {...getRootProps({ className: "dropzoneee" })}>
                          <input {...getInputProps()} />
                          {isDragActive ? (
                            <div
                              className="dropZoneContainer"
                              style={{ borderRadius: "50%" }}
                            >
                              <img
                                src={addimage}
                                alt=""
                                style={{
                                  width: "40px",
                                  height: "40px",
                                  objectFit: "contain",
                                }}
                              />
                            </div>
                          ) : null}
                        </div>
                      )}
                    </Dropzone>
                  </div>

                  <div
                    className="logoRestAddContainer"
                    onClick={this.uploadLogoClick.bind(this)}
                  >
                    {!this.state.uploadButtonDisable && (
                      <img
                        src={addimage}
                        style={{ height: "55%", objectFit: "contain" }}
                        alt=""
                      />
                    )}
                    {this.state.uploadButtonDisable && (
                      <ClapSpinner
                        frontColor="var(--brown1)"
                        backColor="var(--brown1)"
                      />
                    )}
                  </div>
                </div>
              </div>

              <div className="col-md-10 col-10">
                <div className="Restname">
                  <div className="menuResNameContainer">
                    <Form.Control
                      className={"inputStyleForm" + this.state.rtlClass}
                      placeholder={word[this.state.currentLang]["resName"]}
                      type="text"
                      name="resNameValue"
                      // onChange={this.textHandleChange}
                      // value={this.state.resNameValue}
                      onChange={(e) => {
                        let userlangs = JSON.parse(
                          JSON.stringify(this.state.userLangList)
                        );
                        userlangs[this.state.selectedLangIndex].name =
                          e.target.value;
                        this.setState({ userLangList: userlangs });
                      }}
                      value={
                        this.state.userLangList.length > 0 &&
                        this.state.userLangList[this.state.selectedLangIndex]
                          .name !== undefined &&
                        this.state.userLangList[this.state.selectedLangIndex]
                          .name !== null
                          ? this.state.userLangList[
                              this.state.selectedLangIndex
                            ].name
                          : ""
                      }
                      disabled={this.state.buttonDisabled}
                    />
                  </div>

                  {this.state.widthh >= 768 && (
                    <div className="selectLangContainer">
                      <div ref={this.languageButton}>
                        <CustomButton
                          fontSize="12px"
                          minWidth="120px"
                          title={"زبان: " + this.state.currentLangTitle}
                          fontFamily="SFUIDisplay"
                          onClick={this.onLanguageClick.bind(this)}
                        />
                      </div>
                      {this.state.showLangMenu && (
                        <div
                          className="selectLangListContainer"
                          ref={this.languageMenu}
                          style={{
                            top: this.state.langMenuTop,
                            left: this.state.langMenuLeft,
                          }}
                        >
                          {this.state.userLangList.map((item, i) => (
                            <SelectLangItem
                              key={i}
                              direction={item.direction}
                              tag={item.tag}
                              index={i}
                              id={item.languageId}
                              totalCount={this.state.userLangList.length}
                              title={item.title}
                              selected={
                                this.state.selectedLangId === item.languageId
                              }
                              onSelectLang={this.onSelectLang.bind(this)}
                            />
                          ))}
                        </div>
                      )}
                    </div>
                  )}

                  <div className="menuResDesContainer">
                    <Form.Control
                      as="textarea"
                      className={"inputStyleForm" + this.state.rtlClass}
                      style={{
                        minHeight: "100px",
                        maxWidth: "400px",
                        marginTop: "5px",
                      }}
                      placeholder={word[this.state.currentLang]["description"]}
                      type="text"
                      name="descriptionValue"
                      // onChange={this.textHandleChange}
                      // value={this.state.descriptionValue}
                      onChange={(e) => {
                        let userlangs = JSON.parse(
                          JSON.stringify(this.state.userLangList)
                        );
                        userlangs[this.state.selectedLangIndex].descr =
                          e.target.value;
                        this.setState({ userLangList: userlangs });
                      }}
                      value={
                        this.state.userLangList.length > 0 &&
                        this.state.userLangList[this.state.selectedLangIndex]
                          .descr !== undefined &&
                        this.state.userLangList[this.state.selectedLangIndex]
                          .descr !== null
                          ? this.state.userLangList[
                              this.state.selectedLangIndex
                            ].descr
                          : ""
                      }
                      disabled={this.state.buttonDisabled}
                    />

                    <div className="menuResDetailContainer">
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          width: "100%",
                        }}
                      >
                        <img
                          src={Phone}
                          style={{
                            width: "15px",
                            height: "15px",
                            objectFit: "contain",
                            marginLeft: "10px",
                            alignSelf: "center",
                          }}
                          alt=""
                        />
                        <Form.Control
                          className="inputStyleForm"
                          placeholder="تلفن"
                          style={{ marginTop: "5px" }}
                          type="text"
                          name="phoneNumValue"
                          onChange={this.textHandleChange}
                          value={this.state.phoneNumValue}
                          disabled={this.state.buttonDisabled}
                        />
                      </div>

                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          width: "100%",
                        }}
                      >
                        <img
                          src={Email}
                          style={{
                            width: "15px",
                            height: "15px",
                            objectFit: "contain",
                            marginLeft: "10px",
                            alignSelf: "center",
                          }}
                          alt=""
                        />
                        <Form.Control
                          className="inputStyleForm"
                          placeholder="پست الکترونیک"
                          style={{ maxWidth: "400px", marginTop: "5px" }}
                          type="text"
                          name="emailValue"
                          onChange={this.textHandleChange}
                          value={this.state.emailValue}
                          disabled={this.state.buttonDisabled}
                        />
                      </div>

                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          width: "100%",
                        }}
                      >
                        <img
                          src={Address}
                          style={{
                            width: "15px",
                            height: "15px",
                            objectFit: "contain",
                            marginLeft: "10px",
                            alignSelf: "center",
                          }}
                          alt=""
                        />
                        <Form.Control
                          as="textarea"
                          className={"inputStyleForm" + this.state.rtlClass}
                          style={{
                            minHeight: "100px",
                            maxWidth: "400px",
                            marginTop: "5px",
                          }}
                          placeholder={
                            word[this.state.currentLang]["resAddress"]
                          }
                          type="text"
                          name="addressValue"
                          // onChange={this.textHandleChange}
                          // value={this.state.addressValue}
                          onChange={(e) => {
                            let userlangs = JSON.parse(
                              JSON.stringify(this.state.userLangList)
                            );
                            userlangs[this.state.selectedLangIndex].address =
                              e.target.value;
                            this.setState({ userLangList: userlangs });
                          }}
                          value={
                            this.state.userLangList.length > 0 &&
                            this.state.userLangList[
                              this.state.selectedLangIndex
                            ].address !== undefined &&
                            this.state.userLangList[
                              this.state.selectedLangIndex
                            ].address !== null
                              ? this.state.userLangList[
                                  this.state.selectedLangIndex
                                ].address
                              : ""
                          }
                          disabled={this.state.buttonDisabled}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              style={{
                textAlign: "center",
                marginTop: "40px",
                marginBottom: "30px",
                color: "var(--gray3)",
              }}
            >
              &#62;&#62; تغییرات منوی پایین آنی اعمال میشود و فقط برای ذخیره
              اطلاعات متنی رستوران در بالای این متن نیاز به زدن دکمه ذخیره است
              &#60;&#60;
            </div>
            <div
              style={{
                width: "100%",
                height: "2px",
                backgroundColor: "var(--gray2)",
                marginBottom: "20px",
              }}
            />
            <div
              id="categoryContainer"
              className="row bottom-bar"
              style={{
                direction: "ltr",
                marginRight: "0",
                marginLeft: "0",
                display: "flex",
                flexDirection: "row-reverse",
                flexWrap: "noWrap",
                alignItems: "center",
                position: "relative",
                marginTop: "20px",
              }}
            >
              <div
                style={{
                  width: "100%",
                  height: "3px",
                  backgroundColor: "var(--gray4)",
                  position: "absolute",
                  bottom: "0",
                  left: "0",
                }}
              />
              <DragDropContext onDragEnd={this.onDragEnd.bind(this)}>
                <Droppable droppableId="droppable" direction="horizontal">
                  {(provided) => (
                    <div
                      ref={provided.innerRef}
                      className="menu"
                      {...provided.droppableProps}
                    >
                      {this.state.Menu.slice(0)
                        .reverse()
                        .map((item, index) => (
                          <Draggable
                            key={item.id}
                            draggableId={item.id.toString()}
                            index={index}
                          >
                            {(provided) => (
                              <Category
                                rtlClass={this.state.rtlClass}
                                defaultLangId={this.state.default}
                                selectedLangId={this.state.selectedLangId}
                                nameObj={item.nameObj}
                                currentLang={this.state.currentLang}
                                provided={provided}
                                ResetEditMode={this.state.resetCategoryEditMode}
                                businessId={this.state.resID}
                                businessCode={this.props.match.params.id}
                                domRef={provided.innerRef}
                                index={index}
                                id={item.id}
                                priority={item.priority}
                                categoryLength={this.state.Menu.length}
                                isActive={this.state.activeIndex === index}
                                title={item.name}
                                isEnable={item.isEnable}
                                onDeleteCategory={this.onDeleteCategory.bind(
                                  this
                                )}
                                onDuplicateCategory={this.onDuplicateCategory.bind(
                                  this
                                )}
                                updateCategory={this.updateCategory.bind(this)}
                                currenCategoryEditMode={
                                  this.state.currenCategoryEditMode
                                }
                                enterEditMode={(id) => {
                                  this.setState({
                                    newCat: false,
                                    currenCategoryEditMode: id,
                                  });
                                }}
                              />
                            )}
                          </Draggable>
                        ))}
                      {provided.placeholder}
                    </div>
                  )}
                </Droppable>
              </DragDropContext>

              {this.state.newCat && (
                <div
                  className="categoryItemContainer"
                  style={{ margin: "0px 10px" }}
                >
                  <Form.Control
                    className={"inputStyleForm" + this.state.rtlClass}
                    style={{ minWidth: "150px", maxWidth: "150px" }}
                    placeholder={word[this.state.currentLang]["categoryName"]}
                    type="text"
                    name="categoryValue"
                    onChange={this.textHandleChange}
                    value={this.state.categoryValue}
                    disabled={this.state.catButtonDisabled}
                    ref={this.NameInput}
                    onKeyPress={this.handleKeyPress.bind(this)}
                  />
                  <div style={{ width: "30px", marginRight: "5px" }}>
                    <CustomButton
                      loading={this.state.catButtonDisabled}
                      loadingWidth="14px"
                      loadingHeight="14px"
                      title=""
                      img={Tick}
                      backColor="var(--brown2)"
                      onClick={this.doneCatClick}
                    />
                  </div>
                  <div style={{ width: "30px", marginRight: "5px" }}>
                    <CustomButton
                      disabled={this.state.catButtonDisabled}
                      title=""
                      img={Cancel}
                      backColor="var(--black1)"
                      onClick={this.cancelCatClick.bind(this)}
                    />
                  </div>
                </div>
              )}
              {!this.state.newCat && (
                <div style={{ marginRight: "10px" }}>
                  <CustomButton
                    title="دسته جدید"
                    whiteSpace="nowrap"
                    fontFamily="SFUIDisplay"
                    imgMarginLeft={5}
                    flexDirection="row-reverse"
                    img={plus}
                    onClick={this.newCatClick.bind(this)}
                  />
                </div>
              )}
            </div>
          </div>

          {this.state.Menu.length > 0 &&
            this.state.Menu.map((item, i) => {
              return (
                <Group
                  key={i}
                  rtlClass={this.state.rtlClass}
                  currentLang={this.state.currentLang}
                  groupEditId={this.state.groupEditId}
                  onGroupEditMode={this.onGroupEditMode.bind(this)}
                  defaultLangId={this.state.default}
                  selectedLangId={this.state.selectedLangId}
                  nameObj={item.nameObj}
                  onDuplicateFood={this.onDuplicateCategory.bind(this)}
                  onUpdateFood={this.onDuplicateCategory.bind(this)}
                  onDeleteFood={this.onDuplicateCategory.bind(this)}
                  onChangePriority={this.onFoodsChangePriority.bind(this)}
                  unit={this.state.priceUnitValue}
                  businessId={this.state.resID}
                  businessCode={this.props.match.params.id}
                  catId={item.id}
                  title={item.name}
                  foods={item.items}
                  onSubmit={this.onSubmit.bind(this)}
                  orderProcess={this.state.orderProcess}
                />
              );
            })}

          <div style={{ minHeight: "150px" }} />

          <Modal
            show={this.state.ModalShow}
            animation={false}
            onHide={this.hideModal.bind(this)}
            centered
          >
            <Profile
              businessCode={this.props.match.params.id}
              hideModal={this.hideModal.bind(this)}
            />
          </Modal>

          <Modal
            show={this.state.ModalShowOrderProcess}
            animation={true}
            size="sm"
            backdrop="static"
            backdropClassName="backdropClassName"
            onHide={() => {
              this.setState({ ModalShowOrderProcess: false });
            }}
            centered
          >
            <ListViewer
              listType="orderProcess"
              title="برای محصول روال انتخاب کنید"
              currentSelected={this.state.selectedOrderProcess}
              list={this.state.orderProcess}
              loading={false}
              buttonLoading={this.state.addProcessToItemLoading}
              onConfirmOrderProcess={this.onConfirmOrderProcess.bind(this)}
              hideModal={() => {
                this.setState({ ModalShowOrderProcess: false });
              }}
            />
          </Modal>
          {/* <ReactTooltip className="tooltipContent" effect="solid" clickable /> */}
        </div>
      );
    } else {
      return <Loading />;
    }
  }
}
